import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { switchMap } from 'rxjs';

import { CsrfService } from './csrf.service';
import { isBackendUrl } from './backend-url';

const MUTATING_METHODS = ['POST', 'PUT', 'PATCH', 'DELETE'];

export const csrfInterceptor: HttpInterceptorFn = (req, next) => {
  if (!MUTATING_METHODS.includes(req.method.toUpperCase())) {
    return next(req);
  }

  if (!isBackendUrl(req.url)) {
    return next(req);
  }

  if (req.url.endsWith('/csrf')) {
    return next(req);
  }

  const csrfService = inject(CsrfService);

  return csrfService.getToken$().pipe(
    switchMap(csrf =>
      next(
        req.clone({
          setHeaders: {
            [csrf.headerName]: csrf.token,
          },
        })
      )
    )
  );
};
